import { createSlice } from '@reduxjs/toolkit'

export const usersSlice = createSlice({
  name: 'users',
  initialState: {
    detail: [],
    modal: '',
    edit: {},
  },
  reducers: {
    setDetail: (state, action) => {
      state.detail = action.payload
    },
    addDetail: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.detail = [...state.detail, action.payload]
    },
    setEdit: (state, action) => {
      state.edit = action.payload
    },
    removeDetail: (state, action) => {
      state.detail = state.detail.filter((item) => item.id != action.payload)
    },
    showModal: (state, action) => {
      state.modal = action.payload
    },
    editDetail: (state, action) => {
      state.detail = state.detail.map((item) => {
        if (item.id != action.payload.id) return item
        else {
          return action.payload
        }
      })
    },
  },
})

// Action creators are generated for each case reducer function
export const { setDetail, addDetail, removeDetail, showModal, setEdit, editDetail } =
  usersSlice.actions

export default usersSlice.reducer
